import { combineReducers } from 'redux';
// import {routerReducer} from 'react-router-redux';
import { DEFAULT_CURRENCY_FORMAT } from '@eb/intl';

import { locationDuck, collectionsDuck } from '@eb/redux-destination';

import appReducer from './app';
import authReducer from './auth';
import adminReducer from './admin';
import locationReducer from './location';
import contentReducer from './content';
import shareReducer from './share';
import searchReducer from './search';
import brandReducer from './brand';
import paginationReducer from './pagination';
import suggestionsReducer from './suggestions';
import uiReducer from './ui';

const {
    actionTypes: { UPDATE_LOCATION_INFORMATION },
} = locationDuck;

const locationAndSearchInformation = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_LOCATION_INFORMATION) {
        const { path, search, location } = payload;

        nextState = {
            ...nextState,
            [path]: {
                search,
                location,
            },
        };
    }

    return nextState;
};

export default combineReducers({
    collections: collectionsDuck.reducer,
    // routing: d=>d,
    location: locationReducer,
    content: contentReducer,
    brand: brandReducer,
    pagination: paginationReducer,
    auth: authReducer,
    share: shareReducer,
    search: searchReducer,
    suggestions: suggestionsReducer,
    app: appReducer,
    currencyFormat: (state = DEFAULT_CURRENCY_FORMAT) => state,
    locationAndSearchInformation,
    gaSettings: (state = {}) => state,
    botH1: (state = '') => state,
    googleMapsApiKey: (state = '') => state,
    user: (state = {}) => state,
    admin: adminReducer,
    ui: uiReducer,
    shouldShowTrendingSearchPageLink: (state = null) => state,
});
